<template>
  <el-dialog
    :visible.sync="visible"
    :custom-class="customClass"
    :title="title || dialogTitle"
    :width="width"
    :top="top"
    destroy-on-close
    :append-to-body="appendToBody"
    :close-on-click-modal="false"
    @opened="$emit('opened')"
    @close="$emit('close')"
    :before-close="beforeClose"
    :show-close="showClose"
    :close-on-press-escape="closeOnPressEscape"
  >
    <slot v-if="visible"></slot>
    <span slot="footer" class="dialog-footer" v-if="showFooter">
      <slot name="footer-left"></slot>
      <el-divider />
      <el-button type="info" @click="cancel" :disabled="loading" v-if="showCancel">{{
        cancelText
      }}</el-button>
      <el-button
        v-if="showConfirm"
        type="primary"
        :disabled="loading"
        :loading="loading"
        @click="submit"
        >{{ submitText }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
  import { debounce } from 'lodash-es'
  export default {
    name: 'wz-dialog',
    mounted() {
      console.log(this.$slots)
    },
    watch: {
      show(newVal) {
        this.visible = newVal
      },
      visible(newVal) {
        this.$emit('update:show', newVal)
      }
    },
    props: {
      appendToBody: {
        type: Boolean,
        default: true
      },
      submitText: {
        type: String,
        default: ''
      },
      showClose: {
        type: Boolean,
        default: true
      },
      closeOnPressEscape: {
        type: Boolean,
        default: true
      },
      customClass: String,
      loading: Boolean,
      show: Boolean,
      dialogTitle: String,
      title: String,
      width: {
        type: String,
        default: '50vw'
      },
      showConfirm: {
        type: Boolean,
        default: true
      },
      showCancel: {
        type: Boolean,
        default: true
      },
      cancelText: {
        type: String,
        default: ''
      },
      top: {
        type: String,
        default: '15vh'
      },
      beforeClose: {
        type: Function,
        default: () => {}
      },
      showFooter: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      EditEMailValid: debounce(({ vm, val, verifyEmail }) => {
        vm.$emit('submit')
      }, 500),
      submit() {
        this.EditEMailValid({ vm: this })
      },
      cancel() {
        if (this.beforeClose) {
          this.beforeClose()
        } else {
          this.visible = false
        }
      }
    },
    data() {
      return {
        visible: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-divider {
    margin-top: 0;
    margin-bottom: 8px;
  }
</style>
